import Axios, { AxiosRequestConfig } from 'axios';

enum AuthErrorDetail {
  REVOKED = 'Invalid Auth: Token Revoked',
  EXPIRED = 'Invalid Auth: Token Expired',
  INVALID = 'Invalid Auth: Invalid Token',
  NOT_FOUND = 'Invalid Auth: User not found',
}
// TODO: Parameterize!
export const AXIOS_INSTANCE = Axios.create({
  baseURL: process.env['NX_API_URL'],
});

export const localInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    cancelToken: source.token,
  }).then(
    ({ data }) => data,
    (reason) => {
      // Check if the user should be logged out, eg they are unauthorized and one of a specific set of responses is returned.
      const isTokenInvalid =
        reason?.response?.status === 403 &&
        Object.values(AuthErrorDetail).some((s) => reason?.response?.data?.detail?.includes(s));
      if (isTokenInvalid) {
        const platformId = localStorage.getItem('loggedInPlatform');
        if (platformId) {
          // Can't use logoutUser(platformId) because of circular dependency
          console.log('Logging out');
          localStorage.clear();
          const current_location = window.location.origin + '/main/callback';
          // Redirect to FusionAuth logout
          window.location.href = `${
            process.env.NX_FUSIONAUTH_URL || 'UNSET_NX_FUSIONAUTH_URL'
          }/oauth2/logout?post_logout_redirect_uri=${current_location}&client_id=${platformId}`;
        }
      }
      throw reason;
    },
  );

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error: Property 'cancel' does not exist on type 'Promise<T>'
  promise.cancel = () => {
    source.cancel('Query was cancelled by React Query');
  };

  return promise;
};
